export default "__VITE_ASSET__kprPZOVY__"